import { Component, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: 'list-dialog',
    templateUrl: 'list-dialog.component.html',
    styleUrls: ['./list-dialog.component.scss'],
    standalone: false
})
  export class ListDialog {
  
    constructor(
      public dialogRef: MatDialogRef<ListDialog>,
      @Inject(MAT_DIALOG_DATA) public data: any) {}
  }